<template>
  <Container>
    <PageHeader :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <h4 class="card-title mb-0">Additional Costs</h4>
              <b-button @click="clearAdditionalCost" v-b-modal.addon-modal variant="outline-primary">
                Add AddOn
              </b-button>
            </div>

            <b-modal size="lg" id="addon-modal" title="Create Additional Cost" title-class="font-18">
              <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <b-form id="addon-form" @submit.prevent="handleSubmit(onSubmit)">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group label="Title" label-for="title">
                        <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                          <b-form-input
                            v-model="additional_cost.title"
                            id="title"
                            placeholder="Enter title"
                          ></b-form-input>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group label="Price" label-for="price">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <b-form-input
                            id="price"
                            v-model="additional_cost.price"
                            type="number"
                            step=".01"
                            placeholder="Enter price"
                          ></b-form-input>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group label="Lodgings" label-for="lodgings">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <Multiselect
                        id="lodgings"
                        v-model="lodging_ids"
                        :options="lodgingsName"
                        track-by="value"
                        label="text"
                        :multiple="true"
                        :close-on-select="false"
                        deselect-label="Unselect"
                        @select="addRemovedAddOn"
                        @remove="removeAddOn"
                      ></Multiselect>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group label="Charging pulse">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <div class="custom-control custom-radio mb-2">
                            <input
                              type="radio"
                              id="per_booking"
                              v-model="additional_cost.fixed_price"
                              :value="true"
                              name="charging_pulse"
                              class="custom-control-input"
                            />

                            <label class="custom-control-label" for="per_booking">Per booking</label>
                          </div>

                          <div class="custom-control custom-radio custom-control-right">
                            <input
                              type="radio"
                              id="per_day"
                              v-model="additional_cost.fixed_price"
                              :value="false"
                              name="charging_pulse"
                              class="custom-control-input"
                            />

                            <label class="custom-control-label" for="per_day">Per day</label>
                          </div>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group label="Necessity">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <div class="custom-control custom-radio mb-2">
                            <input
                              type="radio"
                              id="required"
                              v-model="additional_cost.required"
                              :value="true"
                              name="necessity"
                              class="custom-control-input"
                            />

                            <label class="custom-control-label" for="required">Required</label>
                          </div>

                          <div class="custom-control custom-radio custom-control-right">
                            <input
                              type="radio"
                              id="optional"
                              v-model="additional_cost.required"
                              :value="false"
                              name="necessity"
                              class="custom-control-input"
                            />

                            <label class="custom-control-label" for="optional">Optional</label>
                          </div>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form>
              </ValidationObserver>

              <template v-slot:modal-footer>
                <b-button variant="secondary" @click="$bvModal.hide('addon-modal')">Close</b-button>
                <b-button form="addon-form" type="submit" variant="primary">Save</b-button>
              </template>
            </b-modal>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length mb-3">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="mx-1" v-model="perPage" size="sm" :options="pageOptions"></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <b-table
                :items="additionalCostItems"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(actions)="row">
                  <b-dropdown variant="default" dropleft>
                    <template v-slot:button-content>
                      <i class="fas fa-bars"></i>
                      <i class="bx bx-caret-down"></i>
                    </template>

                    <b-dropdown-item v-b-modal.addon-modal @click="toggleEdit(row.item.id)">
                      <i class="fa fa-pencil-alt"></i>
                      Edit
                    </b-dropdown-item>

                    <b-dropdown-item :to="{ path: 'additional_costs/' + row.item.id }">
                      <i class="fa fa-info-circle"></i>
                      Details
                    </b-dropdown-item>

                    <b-dropdown-item link-class="text-danger">
                      <i class="fas fa-trash"></i>
                      Delete
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { getLodgings, createAdditionalCost, getAdditionalCosts, updateAdditionalCost } from "@/store/api";

export default {
  page: {
    title: "Additional Costs",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
    PageHeader,
  },

  data() {
    return {
      additional_cost: {
        title: "",
        price: "",
        fixed_price: "",
        required: "",
        add_ons_attributes: [],
      },
      additionalCosts: [],
      lodging_ids: [],
      lodgings: [],
      update: true,
      additionalCostId: "",
      items: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Settings",
          to: "/settings",
        },
        {
          text: "Additional Costs",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      fields: [
        { key: "id" },
        { key: "title" },
        { key: "price" },
        { key: "charging_pulse" },
        { key: "necessity" },
        { key: "actions", tdClass: "text-right" },
      ],
    };
  },

  created() {
    getLodgings().then((response) => (this.lodgings = response));
    getAdditionalCosts().then((response) => (this.additionalCosts = response));
  },

  mounted() {
    this.totalRows = this.items.length;
  },

  computed: {
    rows() {
      return this.lodgingItems.length;
    },

    lodgingsName() {
      return this.lodgings.map((lodging) => ({ value: lodging.id, text: lodging.attributes.name }));
    },

    additionalCostItems() {
      return this.additionalCosts.map((additionalCost) => {
        return {
          id: additionalCost.id,
          title: additionalCost.attributes.title,
          price: additionalCost.attributes.price,
          charging_pulse: additionalCost.attributes.fixed_price ? "Per Booking" : "Per Day",
          necessity: additionalCost.attributes.required ? "Required" : "Optional",
        };
      });
    },
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    removeAddOn(lodging) {
      this.additional_cost.add_ons_attributes.push({ id: lodging.id, lodging_id: lodging.value, _destroy: true });
    },

    addRemovedAddOn(lodging) {
      let addOns = this.additional_cost.add_ons_attributes.filter((addOn) => addOn.lodging_id == lodging.value);
      if (addOns.length != 0) {
        lodging.id = addOns[0].id;
        this.additional_cost.add_ons_attributes = this.additional_cost.add_ons_attributes.filter(
          (addOn) => addOn.lodging_id != lodging.value
        );
      }
    },

    disabledBeforeTomorrow(date) {
      return date < Date.now();
    },

    clearAdditionalCost() {
      this.update = false;
      this.additional_cost.title = "";
      this.additional_cost.price = "";
      this.additional_cost.fixed_price = "";
      this.additional_cost.required = "";
      this.additional_cost.add_ons_attributes = [];
      this.lodging_ids = "";
    },

    toggleEdit(id) {
      this.clearAdditionalCost();
      this.update = true;
      this.additionalCostId = id;
      let selectedAdditionalCost = this.additionalCosts.find((additionalCost) => additionalCost.id == id);
      this.additional_cost.title = selectedAdditionalCost.attributes.title;
      this.additional_cost.price = selectedAdditionalCost.attributes.price;
      this.additional_cost.fixed_price = selectedAdditionalCost.attributes.fixed_price;
      this.additional_cost.required = selectedAdditionalCost.attributes.required;
      this.lodging_ids = selectedAdditionalCost.attributes.add_ons.data.map((addOn) => {
        return {
          text: addOn.attributes.lodging.name,
          value: addOn.attributes.lodging.id,
          id: addOn.id,
          _destroy: false,
        };
      });
    },

    onSubmit() {
      this.$bvModal.hide("addon-modal");
      let addOns = this.lodging_ids.map((lodging_id) => {
        return { id: lodging_id.id, lodging_id: lodging_id.value };
      });
      this.additional_cost.add_ons_attributes = this.additional_cost.add_ons_attributes.concat(addOns);
      if (this.update) {
        updateAdditionalCost(this.additional_cost, this.additionalCostId).then((response) => {
          let index = this.additionalCosts.findIndex((additionalCost) => additionalCost.id === this.additionalCostId);
          this.additionalCosts.splice(index, 1);
          this.additionalCosts.splice(index, 0, response);
        });
      } else {
        createAdditionalCost(this.additional_cost).then((response) => this.additionalCosts.push(response));
      }
    },
  },
};
</script>
